/* eslint-disable */

import axios from "axios";

const SUPPORTED_METHODS = ["GET", "POST", "PUT", "DELETE"];

async function CallApi(
  body,
  url,
  method,
  contentType = "application/json",
  withCredentials = true,
  token = null
) {
  const normalizedMethod = method?.toUpperCase();

  if (!SUPPORTED_METHODS.includes(normalizedMethod)) {
    return "error";
  }

  const headers = {
    "Content-Type": contentType,
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  const config = {
    method: normalizedMethod,
    url,
    headers,
    withCredentials,
  };

  // Add body/data based on method (GET requires empty data object)
  config.data = normalizedMethod === "GET" ? {} : body;

  try {
    return await axios(config);
  } catch (e) {
    return e.response;
  }
}

// Authenticated parameter is strictly for all api which are authenticated
export default async function authApi(payload, isAuthenticated = false) {
  const {
    body,
    url,
    method,
    contentType,
    isWithCredentials,
    tokenhandler = () => null,
    isSecured = false,
  } = payload;
  const token = isSecured ? await tokenhandler() : null;
  return await CallApi(
    body,
    url,
    method,
    contentType,
    isWithCredentials,
    token
  );
}
